import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 21 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M20.512.484a1.674 1.674 0 0 0-2.355 0L7.556 11.008 2.844 6.33a1.674 1.674 0 0 0-2.356 0 1.645 1.645 0 0 0 0 2.338l5.89 5.846c.324.323.75.485 1.177.485.426 0 .853-.161 1.178-.485L20.512 2.823c.65-.646.65-1.693 0-2.339" }, null, -1)
  ])))
}
export default { render: render }